import script from "./PageHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHome.vue?vue&type=script&setup=true&lang=js"

import "./PageHome.vue?vue&type=style&index=0&id=74354be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74354be7"]])

export default __exports__